import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { replaceValuesInsideCurlyBrackets } from 'utils/string';

import { getIsFromInternalCompany } from 'store/auth/selectors';
import { getCurrentSearchValue } from 'store/search/selectors';
import { selectTaskTypeDynamicField } from 'store/system/selectors/taskTypeDynamicField.selectors';

import { getSystem } from './system.selectors';

export const selectTaskTypes = createSelector(getSystem, ({ taskTypes }) => taskTypes);

export const selectTaskTypesValues = createSelector(selectTaskTypes, Object.values);

export const selectTaskTypesFormattedValues = createSelector(
  [selectTaskTypesValues, selectTaskTypeDynamicField, getIsFromInternalCompany],
  (taskTypes, dynamicFieldOptions, isFromInternalCompany) =>
    _.orderBy(
      taskTypes.map(({ name, description, ...taskType }) => ({
        ...taskType,
        slaGroupId: isFromInternalCompany ? taskType.originalSlaGroupId : taskType.slaGroupId,
        name: replaceValuesInsideCurlyBrackets({
          string: name,
          options: dynamicFieldOptions,
          keyToReplace: 'value',
          keyToReplaceWith: 'name',
        }),
        description: replaceValuesInsideCurlyBrackets({
          string: description || '',
          options: dynamicFieldOptions,
          keyToReplace: 'value',
          keyToReplaceWith: 'name',
        }),
      })),
      ['isExcluded', ({ name }) => _.toLower(name)],
      ['desc', 'asc'],
    ),
);

export const selectTaskTypesWithoutCategory = createSelector(
  [selectTaskTypesFormattedValues, getCurrentSearchValue],
  (taskTypes, search) =>
    taskTypes.filter(
      ({ taskCategoryId, name }) => name.match(new RegExp(search, 'gim')) && !taskCategoryId,
    ),
);

export const selectTaskTypeById = memoizeOne(taskTypeId =>
  createSelector(selectTaskTypesFormattedValues, taskTypes =>
    taskTypes.find(taskType => taskType.taskTypeId === taskTypeId),
  ),
);
